var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"amber lighten-1",attrs:{"app":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_vm._t("default",function(){return [_c('span')]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }